// Copyright (c) 2017 Deere & Company

import Report from '../state/report';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetReport = state =>
    Report.update(state, {
        $set: getDefaultState().report
    });

const updateReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().report, action) => {

    const actionTypes = {
        [actions.RESET_PIP_HISTORY_REPORT]: resetReport,
        [actions.UPDATE_PIP_HISTORY_REPORT]: updateReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/pip-history/reducers/report.js